<template>
  <div class="section" :class="main_color">
    <div class="page-content">
      <div class="part">
        <div class="lexique">
          <div class="titre-1">
              Analyse des forces et faiblesses du site
          </div>
          <div class="source">Source : ADEQUATION</div>

          <div class="titre-1">
              Dynamique territoriale et caract&eacute;ristiques des m&eacute;nages
          </div>
          <div class="titre-2">{{lexiqueGeo.commune.label}}{{lexiqueGeo.iris !== null ? " - "+lexiqueGeo.iris.label : ""}}</div>
          <div class="source bloc">
            Source : INSEE {{lexiqueParam.sociodemo_annee_max_demographie}}
          </div>
          <div class="lex-content">
             <p>
            Population, m&eacute;nages, taille des m&eacute;nages, âge des m&eacute;nages, emm&eacute;nagements, part de CSP+, emploi, indice de concentration d’emploi, taux de ch&ocirc;mage, nombre de logements, formes urbaines, statut d’occupation et vacance.
            </p>
          </div>

          <div class="source bloc">
            Source : INSEE FILOSOFI {{lexiqueParam.budget_annee}} - ADEQUATION
          </div>
          <div class="lex-content">
            <p>
              <span class="title">Revenu m&eacute;dian :</span> il est estim&eacute; par
              m&eacute;nage. L&rsquo;INSEE communique des revenus &agrave;
              l&rsquo;unit&eacute; de consommation (UC) ce qui correspond &agrave;
              une pond&eacute;ration des individus au sein des m&eacute;nages.
              Or, ce sont bien les m&eacute;nages qui ach&egrave;tent des logements.
              La donn&eacute;e est retravaill&eacute;e par ADEQUATION et les
              revenus d&rsquo;UC sont convertis en m&eacute;nage afin de
              conna&icirc;tre les vraies capacit&eacute;s d&rsquo;emprunt.
          </p>
          </div>

          <div class="source bloc">
            Source SITADEL {{lexiqueParam.sitadel_annee_max_sitadel}}
          </div>
          <div class="lex-content">
            <span class="title">Nombre de constructions&nbsp;:</span> il s&rsquo;agit des logements
            ordinaires commenc&eacute;s (neuf et Acquisition-Am&eacute;lioration
            (AA)). La donn&eacute;e est moyenn&eacute;e sur les 3
            derni&egrave;res ann&eacute;es.
          </div>

          <div class="titre-1">
              Caract&eacute;ristiques et standing de la r&eacute;sidence
          </div>
           <div class="source">Source : <span v-if="this.active_study.etudeType.nom!=='Flash'">visite de site - </span>GIE Vente</div>


          <div class="titre-1">
              Dynamique du march&eacute; r&eacute;sidentiel
          </div>
          <div class="titre-2">March&eacute; locatif</div>
          <div class="source">Source : Clameur</div>
          <p>
            Les loyers Clameur comprennent les logements neufs et anciens
            r&eacute;nov&eacute;s. Le champ d&rsquo;observation est celui des
            baux nouveaux d&rsquo;habitation, hors donc toutes les indexations
            en cours de bail ou lors d&rsquo;un renouvellement de bail.
            L&rsquo;observatoire porte ainsi exclusivement sur les loyers de
            march&eacute; pour des baux conclus &agrave; l&rsquo;occasion
            d&rsquo;une relocation ou d&rsquo;une location nouvelle. Les loyers
            sont indiqu&eacute;s en &euro;/m&sup2;/mois et sont exprim&eacute;s
            hors charges (HC) et en surface habitable.
          </p>
          <p>
            Ann&eacute;e {{lexiqueParam.clameur_typologie_annee_max_ensemble}}
            pour la donn&eacute;e &agrave; la typologie.
          </p>
          <p>
            Ann&eacute;e {{lexiqueParam.clameur_annee_max_ensemble}} pour la donn&eacute;e globale. Le pourcentage d&rsquo;&eacute;volution de ce loyer se rapporte
            &agrave; l&rsquo;ann&eacute;e n-1.
          </p>

          <div class="titre-2">Dynamisme de la construction locative</div>
          <div class="source">Sources : ADEQUATION - INSEE {{lexiqueParam.sociodemo_annee_max_demographie}}</div>
          <div class="lex-content">
            <p>
              <span class="title">Dynamisme de la construction locative libre :</span> il s’agit d’un ratio de livraisons de logements locatifs neufs pour 1.000 habitants mis en place par ADEQUATION
              pour appr&eacute;cier les tensions à venir sur le march&eacute; locatif local.
          </p>
          </div>
          <div class="lex-content">
            <p>
              <span class="title"> Changement zonage* :</span> Commune qui a vu son zonage Pinel évolué 
              au regard de l&rsquo;arr&ecirc;t&eacute; minist&eacute;riel du 2 octobre 2023.
            </p>
          </div>

          <div class="titre-2">March&eacute; de la promotion immobili&egrave;re </div>
          <div class="source">Source : ADEQUATION</div>
          <div class="lex-content">
            <ul>
              <li>
                <span class="title">Mises en vente&nbsp;:</span> nombre de logements lanc&eacute;s à la commercialisation au cours de la p&eacute;riode.
              </li>
              <li>
                <span class="title">Ventes nettes&nbsp;:</span> total des r&eacute;servations, nettes de d&eacute;sistements.
              </li>
              <li>
                <span class="title">Offre&nbsp;:</span> nombre de logements disponibles à la vente en fin de p&eacute;riode, qu'ils soient sur plan, en chantier ou livr&eacute;s.
              </li>
              <li>
                <span class="title">Prix&nbsp;:</span> indiqu&eacute; pour le logement collectif avec stationnement (hors stat.) en libre TVA 20% et en aid&eacute; TVA 5,5%.
              </li>
            </ul>
            <p>Le pourcentage correspond à l’&eacute;volution par rapport à la p&eacute;riode n-1</p>
          </div>

          <div class="titre-2">March&eacute; de la revente et logements à proximit&eacute; du quartier</div>
          <div class="source">Source : DVF</div>

          <div class="titre-1">
              Capacit&eacute; financi&egrave;re des m&eacute;nages
          </div>
          <div class="source">Source : INSEE FILOSOFI {{lexiqueParam.budget_annee}} – ADEQUATION</div>

          <div class="titre-1">
             Synth&egrave;se et pr&eacute;conisations
          </div>
          <div class="source">Source : ADEQUATION – ADEQUATION EXPERTISE</div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "section-lexique1",
	mixins: [PageMixin],
	props: {
		main_color: { default: "gray" },
	},
	data: function () {
		return {
		};
	},
	computed: {
		...mapGetters(["active_study","editor"]),
		lexiqueParam (){
			return this.active_study.qlikData.parameters.lexiqueParam;
		},
		lexiqueGeo (){
			return this.active_study.qlikData.geo;
		}
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app';
@import '../../../../../assets/css/page';
@import '../../../../../assets/css/lexique';
</style>
